import React from 'react';
import './kisfaludy.css';

export default class Kisfaludy extends React.Component {
    render() {

        return (
            <div className="itemContainer" id="kisfaludy" className="kisfaludy">
                <div>
                    <ul>
                        <li>
                            Kedvezményezett neve: Adél Apartman
                        </li>
                        <li>
                            Támogatott projekt címe: Adél Apartman fejlesztése
                        </li>
                        <li>
                            Pályázat azonosító száma: M-1.1.2-2020-04938
                        </li>
                        <li>
                            Szerződött támogatás összege: 1.000.000 Ft
                        </li>
                        <li>
                            Támogatás mértéke: 100%
                        </li>
                        <li>
                            Támogatott projekt tartalmának rövid bemutatása: bútorok, ajtók, kerítés cseréje. Új szoba kialakítása. 
                        </li>
                        <li style={{display: "none" }}>
                            a támogatott projekt befejezési dátuma
                        </li>
                    </ul>
                    A támogatott projekt a Kisfaludy Turisztikai Fejlesztési Program keretében valósul meg
                </div>

                <div className="banner">
                    <img alt="" src="/assets/cover/banner.png" />
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/content/kisfaludy.js